<div class="not-found">
  <h1>Página não encontrada</h1>
  <p>A página que você está tentando acessar não existe.</p>
  <button [routerLink]="'/painel'" class="btn btn-primary">Voltar para o painel</button>
</div>
